<script lang="ts" setup>import { toRef as _toRef } from 'vue';

import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'
import newMiscDemoGreetingCardIcon from '@consumer/assets/icons/new-misc/demo-greeting-card.svg?svgicon'

const __$temp_1 = (useRecipientLanding()),
  gift = _toRef(__$temp_1, 'gift'),
  complementaryBgColor = _toRef(__$temp_1, 'complementaryBgColor');

const color = computed(() => gift.value.giftlyMetadata?.greetingCardColor ?? complementaryBgColor.value)
</script>

<template>
  <GIcon
    :svg="newMiscDemoGreetingCardIcon"
    style="height: 360px; width: 270px;"
    :style="{
      fill: color,
      color: color,
    }"
  />
</template>
